// src/app/modules/Members/pages/members-table/column-formatters/StatusColumnFormatter.jsx
import React from "react";
import { CheckCircle, XCircle, Clock } from "lucide-react";

const STATUS_CONFIG = {
  active: { label: "Active", pill: "sety-pill-green", icon: CheckCircle },
  suspended: { label: "Suspended", pill: "sety-pill-amber", icon: XCircle },
  pending: { label: "Pending", pill: "sety-pill-purple", icon: Clock },
};

export function StatusColumnFormatter(cellContent, row) {
  const config = STATUS_CONFIG[row.status] || STATUS_CONFIG.pending;
  const Icon = config.icon;

  return (
    <span className={`sety-pill ${config.pill}`}>
      <Icon size={12} />{config.label}
    </span>
  );
}
